import { Checkbox, Divider } from "@mui/material";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import WhiteList from "../../components/whiteList/WhiteList";
import { style } from '@mui/system';

export default function DistributionEditor({ jobInfo,
  setJobInfo,
  eventInfo,
  userCanEditJob,
  escalation,
  setEscalation,
  getJobInfo }) {

  let job = jobInfo?.job;

  function toggleJobDistribution() {
    setJobInfo((PrevState) => ({
      ...PrevState,
      job: { ...PrevState.job, useEvenDistribution: !PrevState.job.useEvenDistribution },
    }));
  }

  let ticketsLimit = eventInfo?.useRunLevelLimit ? eventInfo?.runLimitNumberOfTickets : eventInfo?.eventLimitNumberOfTickets;
  let limitType = eventInfo?.useRunLevelLimit ? "Run" : "Event";

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end'}} >
        <h3 style={{ color: "var(--orange)", fontWeight: '600', margin: '0' }} >Distributions Rules</h3>

        {/* this must display the quantity of the ticketLimits and if the jos is a Event or part od a Run */}
        <div style={{ display: 'flex', alignItems: 'center' }} >
          <ConfirmationNumberIcon color="primary" sx={{ margin: '0 0.25em 0 0' }} />
          <p style={{ margin: '0 0.25em 0 0', fontWeight: '600' }} >Tickets Limits: </p>
          <p> {ticketsLimit} per {limitType} </p>
        </div>

      </div>


      <div className="row-modal" style={{ justifyContent: 'space-between' }} >
        <div style={{ display: "flex", flexDirection: 'row' }} >

          <div style={{ margin: '0 2em 0 0', display: 'flex', alignItems: 'center' }} >
            <Checkbox onChange={toggleJobDistribution} disabled={!userCanEditJob} type="checkbox" id="activeEmail" name="Even Distribution" checked={jobInfo?.useEvenDistribution == true} />
            <label htmlFor="activeEmail" style={{ fontSize: "1.5em" }}  >Even Distribution</label>
          </div>

          <div style={{ margin: '0 0 0 0', display: 'flex', alignItems: 'center' }} >
            <Checkbox onChange={toggleJobDistribution} disabled={!userCanEditJob} type="checkbox" id="firstComeFirstServe" name="First Come First Serve" checked={!jobInfo?.useEvenDistribution} />
            <label htmlFor="firstComeFirstServe" style={{ fontSize: "1.5em" }}  >First Come First Serve</label>
          </div>

        </div>

        <div style={{ margin: '0 0 0 0', display: 'flex', alignItems: 'center' }} >
          <Checkbox type="checkbox" id="onePurchaseLimit" name="One Purchase Limit" checked={eventInfo?.runLimit1PurchasePerBuyer || eventInfo?.eventLimit1PurchasePerBuyer} disabled={true} />
          <label htmlFor="firstComeFirstServe" style={{ fontSize: "1.5em" }}  > One Purchase Limit </label>
        </div>


      </div>

      <WhiteList
        jobInfo={jobInfo}
        setJobInfo={setJobInfo}
        eventInfo={eventInfo}
        userCanEditJob={userCanEditJob}
        escalation={escalation}
        setEscalation={setEscalation}
        getJobInfo={getJobInfo}
      />


    </div>
  )
}